/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClosedCaptionsOutlineIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABo0lEQVR4nN2VzSsEcRjHZ8lLSREXIjk4OCkHBxEX22bmeZmt2eeZRXuQvStKOWxO1tnVQe4OyokLV7k5OUr8AUIuXvrtzgjjZXco8dSvZnqens/vmec7z2NZ/8Y8z6tHljUguUTWxzgHWC6QtWhyRQDGETcxRk8xAgjoj0QyHPcrOOyPhJW8V0GJHjf5l3n+JwDA6wXWaSIfJiamm176mP2hsk/GPc+rrRqALEtAcv8sQZJzO+335fP5OmDZeS1PPRzL5RorBjhuZhBZH5B1AxGbjbKA5dh2MwOIOh/EzpmqgGQWWPdtO9taMQBIV0rvqJ2ROJIDID39Vg+QdB1Z7yzLSkQBeoIke98COCQL5plZ+kO/4/jt5epk1/xIhUKhJnAlmGfaqgIQSTeyXCPpEbBmkGUZWW8cliSwpEuxJJvoqo2sW2Z+ue5UR8WA0o1Zksh6FijoHkm3TcPLsbIIrFdln96anlVVQWhG36471UWUa3kbn0qlGibT2Z5QnrEAcez3ABCMazNy4yYnktHPxvWPLRwgXf1gZWoxrOTHV6b1V+0Jkd2QnaqppMcAAAAASUVORK5CYII=)
 */
export const ClosedCaptionsOutlineIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Zm0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8.78 16.15a3.16 3.16 0 0 1-2.95-1.76 4.39 4.39 0 0 1-.43-2.01c0-.77.14-1.44.43-2 .29-.58.69-1 1.2-1.31.5-.3 1.1-.46 1.75-.46 1.3 0 2.23.5 2.77 1.52l-1.14.9a1.86 1.86 0 0 0-.67-.76c-.3-.18-.61-.28-.96-.28a1.7 1.7 0 0 0-1.6 1.1c-.17.35-.25.78-.25 1.29 0 .5.08.94.24 1.3.16.36.38.63.67.8a1.73 1.73 0 0 0 1.89 0c.29-.17.52-.43.68-.75l1.14.9c-.26.5-.64.87-1.11 1.13-.47.26-1.02.39-1.66.39ZM15.53 16.15c-.66 0-1.25-.15-1.76-.45-.5-.31-.9-.75-1.2-1.32a4.39 4.39 0 0 1-.42-2c0-.77.14-1.44.43-2 .28-.58.68-1 1.2-1.31.5-.3 1.09-.46 1.75-.46 1.3 0 2.23.5 2.77 1.52l-1.15.9a1.86 1.86 0 0 0-.67-.76c-.28-.18-.6-.28-.95-.28a1.7 1.7 0 0 0-1.6 1.1c-.17.35-.25.78-.25 1.29 0 .5.08.94.24 1.3a1.7 1.7 0 0 0 1.6 1.08 1.83 1.83 0 0 0 1.63-1.03l1.15.9c-.27.5-.64.87-1.11 1.13-.47.26-1.03.39-1.66.39Z"
        className={colorClass}
      />
    </svg>
  );
};
